import { render, staticRenderFns } from "./InstagramInterface.vue?vue&type=template&id=7e2bfb98"
import script from "./InstagramInterface.vue?vue&type=script&lang=js"
export * from "./InstagramInterface.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e2bfb98')) {
      api.createRecord('7e2bfb98', component.options)
    } else {
      api.reload('7e2bfb98', component.options)
    }
    module.hot.accept("./InstagramInterface.vue?vue&type=template&id=7e2bfb98", function () {
      api.rerender('7e2bfb98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/posts/components/feed/InstagramInterface.vue"
export default component.exports